// seller-portal — Arabic (RTL). Keys are the English source text.
export default {
  "Language": "اللغة",
  "PartHub Seller": "PartHub للبائعين",
  "Dashboard": "لوحة التحكم",
  "Inventory": "المخزون",
  "Orders": "الطلبيات",
  "Requests": "طلبات القطع",
  "Reviews": "التقييمات",
  "Insights": "التحليلات",
  "Store": "المتجر",
  "+ Add part": "+ أضف قطعة",
  "Seller": "البائع",
  "Seller session active": "جلسة البائع نشطة",
  "Sign out": "تسجيل الخروج",
  "Home": "الرئيسية",
  "Parts": "القطع",
  "Failed to load compatibility": "تعذّر تحميل التوافقات",
  "Preset loaded: {name}": "تم تحميل النموذج: {name}",
  "Make is required.": "العلامة مطلوبة.",
  "Model is required.": "الطراز مطلوب.",
  "Year start is required.": "سنة البداية مطلوبة.",
  "Compatibility row added.": "تمت إضافة التوافق.",
  "Failed to add compatibility row": "تعذّرت إضافة التوافق",
  "Add comma-separated years first.": "أضف أولاً سنوات مفصولة بفواصل.",
  "Added 1 compatibility row.": "تمت إضافة توافق واحد.",
  "Added {n} compatibility rows.": "تمت إضافة {n} توافقات.",
  "Added {n} row(s). {failed} duplicate or failed row(s) were skipped.": "تمت إضافة {n} سطر. تم تجاهل {failed} سطر مكرر أو فاشل.",
  "No bulk rows were added.": "لم تتم إضافة أي سطر.",
  "Bulk add failed": "فشلت الإضافة الجماعية",
  "Compatibility row deleted.": "تم حذف التوافق.",
  "Failed to delete row": "تعذّر حذف السطر",
  "Compatibility row duplicated.": "تم نسخ التوافق.",
  "Could not duplicate row": "تعذّر نسخ السطر",
  "Quick presets": "نماذج سريعة",
  "Load common vehicle fitment presets, then fine-tune before saving rows.": "حمّل سيارة شائعة، ثم عدّل قبل الحفظ.",
  "Compatibility editor": "توافق السيارات",
  "Add exact fitment rows or bulk-add multiple model years for this part.": "أضف توافقات دقيقة أو عدة سنوات دفعة واحدة.",
  "Make": "العلامة",
  "Model": "الطراز",
  "Engine": "المحرك",
  "Year start": "سنة البداية",
  "Year end": "سنة النهاية",
  "Trim": "الفئة",
  "Notes": "ملاحظات",
  "Verified seller fitment": "توافق تحقّق منه البائع",
  "Saving...": "جارٍ الحفظ…",
  "Add single row": "أضف سطراً",
  "Bulk add years": "أضف عدة سنوات",
  "Add multiple year-specific compatibility rows at once using comma-separated years.": "أضف عدة سنوات دفعة واحدة، مفصولة بفواصل.",
  "Years": "السنوات",
  "Parsed years: {years}": "السنوات المقروءة: {years}",
  "none": "لا شيء",
  "Processing...": "جارٍ المعالجة…",
  "Current compatibility rows": "التوافقات الحالية",
  "Manage the vehicle rows already linked to this part.": "أدر السيارات المرتبطة بهذه القطعة.",
  "Loading compatibility rows...": "جارٍ تحميل التوافقات…",
  "No compatibility rows linked yet.": "لا توجد توافقات بعد.",
  "Duplicate": "نسخ",
  "Delete": "حذف",
  "Checking seller session...": "جارٍ التحقق من الجلسة…",
  "Message from PartHub:": "رسالة من PartHub:",
  "Could not load your store status.": "تعذّر تحميل حالة متجرك.",
  "Try again": "أعد المحاولة",
  "Store setup": "إعداد المتجر",
  "All required steps are done.": "اكتملت كل الخطوات المطلوبة.",
  "1 required step left.": "بقيت خطوة مطلوبة واحدة.",
  "{n} required steps left.": "بقيت {n} خطوات مطلوبة.",
  "Store setup progress": "تقدّم إعداد المتجر",
  "Required": "مطلوب",
  "Recommended": "مُستحسن",
  "Could not load your store status": "تعذّر تحميل حالة متجرك",
  "Offer sent": "تم إرسال العرض",
  "Accepted 🎉": "مقبول 🎉",
  "Not selected": "غير مختارة",
  "Withdrawn": "مسحوب",
  "Please enter your email and password.": "أدخل بريدك الإلكتروني وكلمة المرور.",
  "Please enter your name.": "أدخل اسمك.",
  "Use at least 8 characters for your password.": "استعمل 8 أحرف على الأقل لكلمة المرور.",
  "Could not create your account.": "تعذّر إنشاء حسابك.",
  "Seller sign-in failed.": "فشل دخول البائع.",
  "Seller auth": "فضاء البائع",
  "You are already signed in": "أنت مسجّل الدخول بالفعل",
  "Continue to your dashboard, inventory, or orders.": "تابع إلى لوحة التحكم أو المخزون أو الطلبيات.",
  "Email": "البريد الإلكتروني",
  "Seller account": "حساب البائع",
  "Role": "الدور",
  "Continue": "متابعة",
  "Seller auth foundation": "فضاء البائع",
  "Sell your parts on PartHub": "بع قطعك على PartHub",
  "Sign in to seller portal": "الدخول إلى بوابة البائع",
  "Create a free seller account, set up your store in a few minutes, and start answering buyer requests.": "أنشئ حساب بائع مجاناً، جهّز متجرك في دقائق، وابدأ بالرد على طلبات المشترين.",
  "Access your dashboard, inventory, orders, media tools, and store settings.": "ادخل إلى لوحة التحكم والمخزون والطلبيات والصور وإعدادات المتجر.",
  "Seller workflow": "عملك كبائع",
  "Manage your inventory from one place.": "أدر مخزونك من مكان واحد.",
  "Upload media and attach images to parts.": "أضف صوراً لقطعك.",
  "Review orders and store settings.": "تابع طلبياتك وإعدادات متجرك.",
  "Sign in": "تسجيل الدخول",
  "Create seller account": "إنشاء حساب بائع",
  "Create your seller account": "أنشئ حساب البائع",
  "Seller sign in": "دخول البائع",
  "Next you'll set up your store. PartHub reviews new stores before their parts go live.": "بعدها ستجهّز متجرك. يراجع PartHub المتاجر الجديدة قبل نشر قطعها.",
  "Use your seller account credentials to continue.": "استعمل بيانات حساب البائع للمتابعة.",
  "Your name": "اسمك",
  "Phone (optional)": "الهاتف (اختياري)",
  "Password": "كلمة المرور",
  "Creating account…": "جارٍ إنشاء الحساب…",
  "Signing in…": "جارٍ الدخول…",
  "Create account": "إنشاء حساب",
  "Active Parts": "القطع النشطة",
  "Total Orders": "مجموع الطلبيات",
  "Pending Orders": "طلبيات معلّقة",
  "Avg Rating": "متوسط التقييم",
  "Seller dashboard": "لوحة تحكم البائع",
  "Welcome back, {name}": "مرحباً بعودتك، {name}",
  "Welcome back": "مرحباً بعودتك",
  "Review store activity, inventory health, orders, and quick actions from one place.": "نشاط المتجر والمخزون والطلبيات والإجراءات السريعة في مكان واحد.",
  "+ Add new part": "+ أضف قطعة جديدة",
  "View orders": "عرض الطلبيات",
  "Quick actions": "إجراءات سريعة",
  "Jump directly into the most common seller workflows.": "انتقل مباشرة إلى أكثر المهام استعمالاً.",
  "+ Create new part": "+ قطعة جديدة",
  "Upload media": "رفع الصور",
  "Manage inventory": "إدارة المخزون",
  "Store settings": "إعدادات المتجر",
  "Recent orders": "أحدث الطلبيات",
  "Quick preview of the newest seller-side order activity.": "نظرة سريعة على أحدث الطلبيات.",
  "Loading dashboard activity...": "جارٍ تحميل النشاط…",
  "Order": "طلبية",
  "Buyer": "مشترٍ",
  "No recent orders yet. New seller orders can appear here once order activity grows.": "لا توجد طلبيات حديثة. ستظهر طلبياتك الجديدة هنا.",
  "View all orders →": "← كل الطلبيات",
  "Low stock parts": "قطع بمخزون قليل",
  "Suggested next steps": "خطوات مقترحة",
  "Add more parts to increase storefront coverage.": "أضف المزيد من القطع لتظهر أكثر.",
  "Upload better product images to improve listing quality.": "أضف صوراً أفضل لتحسين عروضك.",
  "Complete store settings to strengthen seller presence.": "أكمل إعدادات متجرك.",
  "Portal scope": "بوابة البائع",
  "Ready to expand": "جاهز للتوسّع",
  "Foundation active": "نشط",
  "Failed to load insights": "تعذّر تحميل التحليلات",
  "High missed demand detected": "طلب كبير غير ملبّى",
  "Buyers are searching for \"{query}\" and not finding results. Strong opportunity to add inventory for {vehicle}.": "يبحث المشترون عن «{query}» دون نتائج. فرصة جيدة لإضافة مخزون لـ {vehicle}.",
  "unlabeled part": "قطعة بدون اسم",
  "target makes": "العلامات المستهدفة",
  "target models": "الطرازات المستهدفة",
  "Add matching part": "أضف القطعة",
  "Some listings have no compatibility data": "عروض بدون بيانات توافق",
  "{n} listing(s) currently have zero compatibility rows. These parts may rank weaker and convert worse for vehicle-aware buyers.": "{n} عرض بدون أي توافق. هذه القطع تظهر في ترتيب أدنى وتُباع أقل.",
  "Improve inventory": "حسّن المخزون",
  "Low stock risk on active inventory": "خطر نفاد المخزون",
  "{n} listing(s) are running low on stock. Replenishing them early reduces missed orders and keeps search coverage stable.": "{n} عرض على وشك النفاد. أعد التزويد مبكراً حتى لا تفوتك طلبيات.",
  "Review inventory": "راجع المخزون",
  "Vehicle niche worth targeting": "سيارة تستحق الاستهداف",
  "One of the strongest buyer demand signals is {vehicle}. Prioritize fitment-rich stock for this vehicle niche.": "{vehicle} من أكثر السيارات طلباً. أعطِ الأولوية لقطع متوافقة معها.",
  "Create targeted listing": "أنشئ عرضاً موجّهاً",
  "No critical recommendation yet": "لا توجد توصيات بعد",
  "Your insights are loading normally, but there is not enough demand data yet to produce a high-confidence seller recommendation.": "لا توجد بيانات طلب كافية بعد لتقديم توصية موثوقة.",
  "Add new part": "أضف قطعة",
  "Seller insights": "تحليلات البائع",
  "Understand demand, missed searches, and which vehicle niches are worth stocking.": "افهم الطلب وعمليات البحث بدون نتائج والسيارات التي تستحق التخزين.",
  "Total parts": "مجموع القطع",
  "All seller listings": "كل عروضك",
  "Active parts": "القطع النشطة",
  "Currently live in the marketplace": "منشورة حالياً",
  "Pending parts": "قطع قيد المراجعة",
  "Listings waiting for approval": "عروض تنتظر الموافقة",
  "Order items": "قطع مطلوبة",
  "Demand already converted into orders": "طلب تحوّل إلى طلبيات",
  "Recommended actions": "إجراءات مقترحة",
  "What you should do next based on real marketplace demand signals.": "ما يجب فعله حسب الطلب الفعلي.",
  "Top buyer demand": "أكثر ما يبحث عنه المشترون",
  "The most common query demand flowing through the marketplace.": "أكثر عمليات البحث شيوعاً.",
  "No demand signals yet.": "لا توجد بيانات بعد.",
  "{n} searches": "{n} بحث",
  "Avg. results in market: {n}": "متوسط النتائج: {n}",
  "Missed demand": "طلب غير ملبّى",
  "Searches with zero results. These are stocking opportunities.": "عمليات بحث بدون نتائج: فرص للتخزين.",
  "No missed demand captured yet.": "لا يوجد طلب غير ملبّى بعد.",
  "No keyword": "بدون كلمة",
  "{n} misses": "{n} بدون نتيجة",
  "any make": "أي علامة",
  "any model": "أي طراز",
  "any year": "أي سنة",
  "Top vehicle demand": "أكثر السيارات طلباً",
  "Vehicle combinations buyers search for most.": "السيارات الأكثر بحثاً.",
  "No vehicle demand data yet.": "لا توجد بيانات سيارات بعد.",
  "year unspecified": "سنة غير محددة",
  "Inventory snapshot": "نظرة على المخزون",
  "Recent seller listings and compatibility coverage.": "أحدث العروض وتوافقاتها.",
  "No inventory found.": "لا يوجد مخزون.",
  "stock: {n}": "المخزون: {n}",
  "price: {price}": "السعر: {price}",
  "fitment rows: {n}": "التوافقات: {n}",
  "Please choose an image first.": "اختر صورة أولاً.",
  "Upload failed": "فشل الرفع",
  "Upload product media": "رفع صور القطع",
  "Upload JPG, PNG, or WEBP images directly to R2.": "صور JPG أو PNG أو WEBP.",
  "Uploading...": "جارٍ الرفع…",
  "Upload image": "ارفع الصورة",
  "Upload complete": "اكتمل الرفع",
  "Use this URL when attaching images to a part.": "استعمل هذا الرابط لإضافة الصورة إلى قطعة.",
  "Key:": "المفتاح:",
  "Filename:": "اسم الملف:",
  "Type:": "النوع:",
  "Uploaded preview": "معاينة",
  "Page not found": "الصفحة غير موجودة",
  "This seller portal route does not exist or is not ready yet.": "هذه الصفحة غير موجودة.",
  "Go to dashboard": "إلى لوحة التحكم",
  "Failed to load order details": "تعذّر تحميل تفاصيل الطلبية",
  "Loading order details...": "جارٍ تحميل الطلبية…",
  "Order not found": "الطلبية غير موجودة",
  "Order details": "تفاصيل الطلبية",
  "Review buyer information, line items, payment state, and shipping progress.": "المشتري والقطع والدفع والتوصيل.",
  "Back to orders": "العودة إلى الطلبيات",
  "Order status": "حالة الطلبية",
  "Payment": "الدفع",
  "Shipping": "التوصيل",
  "Total": "المجموع",
  "Line items": "القطع",
  "Products included in this order.": "القطع في هذه الطلبية.",
  "Part": "القطعة",
  "Unit price: {price}": "سعر القطعة: {price}",
  "Line total: {price}": "المجموع: {price}",
  "No line items available for this order yet.": "لا توجد قطع في هذه الطلبية.",
  "Order notes": "ملاحظات الطلبية",
  "No notes attached to this order.": "لا توجد ملاحظات.",
  "Buyer information": "معلومات المشتري",
  "Buyer name": "اسم المشتري",
  "Phone": "الهاتف",
  "City": "المدينة",
  "Address": "العنوان",
  "Status summary": "ملخّص الحالة",
  "Order status:": "حالة الطلبية:",
  "Payment status:": "حالة الدفع:",
  "Shipping status:": "حالة التوصيل:",
  "Created at:": "تاريخ الإنشاء:",
  "Failed to load seller orders": "تعذّر تحميل الطلبيات",
  "Loading seller orders...": "جارٍ تحميل الطلبيات…",
  "Orders management": "إدارة الطلبيات",
  "Seller orders": "طلبيات المتجر",
  "Review incoming orders, monitor statuses, and move into order details.": "تابع طلبياتك وحالاتها.",
  "Total orders": "مجموع الطلبيات",
  "Pending": "قيد الانتظار",
  "Shipped": "تم الشحن",
  "Delivered": "تم التوصيل",
  "Search order id, buyer, status...": "رقم الطلبية، المشتري، الحالة…",
  "All statuses": "كل الحالات",
  "Confirmed": "مؤكَّد",
  "Processing": "قيد التجهيز",
  "Cancelled": "ملغى",
  "Reset": "إعادة ضبط",
  "{n} orders found": "{n} طلبية",
  "No orders yet": "لا توجد طلبيات بعد",
  "New seller orders will appear here when buyer activity starts.": "ستظهر طلبياتك هنا.",
  "Payment: {status}": "الدفع: {status}",
  "Buyer: {name}": "المشتري: {name}",
  "Email: {email}": "البريد: {email}",
  "Shipping: {status}": "التوصيل: {status}",
  "Created: {date}": "أُنشئ: {date}",
  "View order": "عرض الطلبية",
  "Confirm exact engine code before sale.": "أكّد رمز المحرك قبل البيع.",
  "Add make/model/year compatibility rows after creation.": "أضف توافقات العلامة/الطراز/السنة بعد الإنشاء.",
  "Specify front / rear axle in compatibility details.": "حدّد أمامي / خلفي في تفاصيل التوافق.",
  "Brake fitment should match make/model/year precisely.": "يجب أن تطابق الفرامل العلامة والطراز والسنة بدقة.",
  "Include engine variant in fitment rows.": "اذكر نوع المحرك في التوافق.",
  "Filter compatibility converts better when SKU and engine are both clear.": "الفلتر يُباع أفضل عندما يكون SKU والمحرك واضحين.",
  "Add make/model/year ranges for the exact engine variants using this turbo.": "أضف السنوات للمحركات التي تستعمل هذا التوربو.",
  "Brake parts convert better when compatibility rows and axle position are clear.": "قطع الفرامل تُباع أفضل مع توافق وموضع واضحين.",
  "Filters need SKU and engine compatibility for stronger buyer confidence.": "الفلاتر تحتاج SKU وتوافق المحرك لثقة أكبر.",
  "Add a clear part title first to unlock better suggestions.": "أضف عنواناً واضحاً للحصول على اقتراحات.",
  "Failed to load part form data": "تعذّر تحميل النموذج",
  "Part title is required.": "عنوان القطعة مطلوب.",
  "Part slug is required.": "رابط القطعة (slug) مطلوب.",
  "Category is required.": "الصنف مطلوب.",
  "Price is required.": "السعر مطلوب.",
  "Enter the price in dirhams, e.g. 350 or 349,90.": "أدخل السعر بالدرهم، مثلاً 350 أو 349,90.",
  "Enter the compare-at price in dirhams, e.g. 420.": "أدخل السعر قبل التخفيض بالدرهم، مثلاً 420.",
  "Quantity is required.": "الكمية مطلوبة.",
  "Part created successfully.": "تم إنشاء القطعة.",
  "Failed to create part": "تعذّر إنشاء القطعة",
  "Loading part creation form...": "جارٍ تحميل النموذج…",
  "Create part": "أنشئ القطعة",
  "Add a new listing": "عرض جديد",
  "Create a seller listing with core product data, stock, pricing, and fitment notes.": "أنشئ عرضاً بمعلومات القطعة والمخزون والسعر والتوافق.",
  "Back to inventory": "العودة إلى المخزون",
  "Part details": "تفاصيل القطعة",
  "Fill in the essential fields for a clean seller listing.": "املأ الحقول الأساسية.",
  "Title": "العنوان",
  "Bosch Front Brake Pads Set": "مثلاً: طقم فحمات أمامية Bosch",
  "Slug": "الرابط (slug)",
  "Use slug": "استعمل",
  "Brand": "العلامة",
  "Select brand": "اختر العلامة",
  "Match": "متوافقة",
  "Category": "الصنف",
  "Select category": "اختر الصنف",
  "Suggest": "اقترح",
  "Price (MAD)": "السعر (درهم)",
  "Compare-at price (MAD)": "السعر قبل التخفيض (درهم)",
  "Quantity": "الكمية",
  "Condition": "الحالة",
  "New": "جديد",
  "Used": "مستعملة",
  "Refurbished": "مُجدّدة",
  "Status": "الحالة",
  "Active": "نشط",
  "Draft": "مسودة",
  "Image URL": "رابط الصورة",
  "Description": "الوصف",
  "Describe the part, condition, and trust signals...": "صِف القطعة وحالتها…",
  "Fitment notes": "ملاحظات التوافق",
  "Weight (kg)": "الوزن (كغ)",
  "Featured listing": "عرض مميّز",
  "Creating...": "جارٍ الإنشاء…",
  "Cancel": "إلغاء",
  "Listing assistant": "مساعد العرض",
  "Suggestions based on your current inputs.": "اقتراحات حسب ما أدخلته.",
  "Suggested slug": "رابط مقترح",
  "Waiting for title": "في انتظار العنوان",
  "Suggested category": "صنف مقترح",
  "No strong category signal yet": "لا يوجد صنف واضح بعد",
  "Suggested brand": "علامة مقترحة",
  "No brand detected in title": "لا توجد علامة في العنوان",
  "Title suggestions": "اقتراحات للعنوان",
  "Add a clearer title to unlock title cleanup suggestions.": "أضف عنواناً أوضح للحصول على اقتراحات.",
  "Use title": "استعمل",
  "Fitment guidance": "إرشادات التوافق",
  "Listings with stronger compatibility data usually rank better and convert better for vehicle-aware buyers.": "العروض ببيانات توافق تظهر أعلى وتُباع أكثر.",
  "Compatibility suggestions": "اقتراحات التوافق",
  "Quick notes you can insert into fitment notes before adding structured compatibility rows.": "ملاحظات سريعة تضيفها قبل إدخال التوافقات.",
  "Add a clearer vehicle or part title to unlock compatibility suggestions.": "أضف سيارة أو عنواناً أوضح للحصول على اقتراحات.",
  "Add to notes": "أضف إلى الملاحظات",
  "Choose an image first.": "اختر صورة أولاً.",
  "Create part failed": "فشل إنشاء القطعة",
  "Create part + upload image": "أنشئ القطعة + صورة",
  "Upload product media to R2, then save the part in D1 in one flow.": "ارفع الصورة واحفظ القطعة في خطوة واحدة.",
  "Front Brake Pads Kit": "طقم فحمات فرامل أمامية",
  "Seller ID": "معرّف البائع",
  "Category ID": "معرّف الصنف",
  "Brand ID": "معرّف العلامة",
  "Describe the part...": "صِف القطعة…",
  "Product image": "صورة القطعة",
  "Upload first, then the image URL will be attached automatically.": "ارفع الصورة أولاً وسيُضاف رابطها تلقائياً.",
  "Preview": "معاينة",
  "Saving part...": "جارٍ حفظ القطعة…",
  "Part created successfully": "تم إنشاء القطعة",
  "ID:": "المعرّف:",
  "Title:": "العنوان:",
  "Slug:": "الرابط:",
  "Price:": "السعر:",
  "Image:": "الصورة:",
  "No image": "لا صورة",
  "Add make/model/year compatibility rows after saving changes.": "أضف التوافقات بعد الحفظ.",
  "Turbo parts perform better when engine variants and exact year ranges are explicit.": "التوربو يُباع أفضل مع محركات وسنوات محددة.",
  "Brake listings convert better when fitment rows and axle/position context are clear.": "الفرامل تُباع أفضل مع توافق وموضع واضحين.",
  "Filters should include SKU and engine compatibility for stronger buyer trust.": "الفلاتر يجب أن تتضمن SKU وتوافق المحرك.",
  "Add or refine the title to unlock stronger listing suggestions.": "دقّق العنوان للحصول على اقتراحات أفضل.",
  "Failed to load edit form data": "تعذّر تحميل النموذج",
  "Part not found": "القطعة غير موجودة",
  "Failed to load part": "تعذّر تحميل القطعة",
  "Part updated successfully.": "تم تحديث القطعة.",
  "Failed to update part": "تعذّر تحديث القطعة",
  "Loading part editor...": "جارٍ التحميل…",
  "Edit part": "تعديل القطعة",
  "Update your listing": "حدّث عرضك",
  "Refine your seller listing, adjust stock, pricing, and improve product presentation.": "عدّل عرضك والمخزون والسعر وطريقة العرض.",
  "Edit your product data and keep the listing accurate.": "حافظ على دقة عرضك.",
  "PartHub didn't approve this listing": "لم يوافق PartHub على هذا العرض",
  "PartHub archived this listing": "أرشف PartHub هذا العرض",
  "Fix the issue and save: the listing goes back for review.": "أصلح المشكلة واحفظ: سيعود العرض للمراجعة.",
  "Archived": "مؤرشف",
  "Save changes": "حفظ التغييرات",
  "Suggestions based on your current listing fields.": "اقتراحات حسب عرضك.",
  "Refine the title to unlock cleanup suggestions.": "دقّق العنوان للحصول على اقتراحات.",
  "Listings with clearer compatibility context usually rank better and reduce buyer hesitation.": "التوافق الواضح يحسّن الترتيب ويطمئن المشتري.",
  "Quick notes you can insert into fitment notes before refining structured compatibility rows.": "ملاحظات سريعة تضيفها قبل تعديل التوافقات.",
  "Refine the title with vehicle or part context to unlock compatibility suggestions.": "اذكر السيارة أو القطعة في العنوان للحصول على اقتراحات.",
  "Failed to load seller inventory": "تعذّر تحميل المخزون",
  "Loading seller inventory...": "جارٍ تحميل المخزون…",
  "Inventory management": "إدارة المخزون",
  "Your parts inventory": "مخزون قطعك",
  "Search, review, and manage your part listings from one place.": "ابحث وأدر عروضك من مكان واحد.",
  "+ Create part": "+ قطعة جديدة",
  "Drafts": "المسودات",
  "Low stock": "مخزون قليل",
  "Search title, SKU, brand, category...": "العنوان، SKU، العلامة، الصنف…",
  "All stock states": "كل حالات المخزون",
  "In stock": "متوفّرة",
  "Out of stock": "غير متوفّرة",
  "{n} parts found": "{n} قطعة",
  "No parts yet": "لا توجد قطع بعد",
  "Create your first listing to start building your seller inventory.": "أنشئ أول عرض لك.",
  "Unknown brand": "علامة غير معروفة",
  "Uncategorized": "بدون صنف",
  "Not approved:": "غير مقبول:",
  "Archived:": "مؤرشف:",
  "Edit the listing and save it to send it for review again.": "عدّل العرض واحفظه لإرساله للمراجعة من جديد.",
  "No description available.": "لا يوجد وصف.",
  "Failed to load request": "تعذّر تحميل الطلب",
  "Enter a valid price in MAD": "أدخل سعراً صحيحاً بالدرهم",
  "Offer updated.": "تم تحديث العرض.",
  "Offer sent to the buyer.": "تم إرسال العرض إلى المشتري.",
  "Could not send offer": "تعذّر إرسال العرض",
  "Withdraw your offer?": "سحب عرضك؟",
  "Offer withdrawn.": "تم سحب العرض.",
  "Could not withdraw offer": "تعذّر سحب العرض",
  "Request not found": "الطلب غير موجود",
  "← Back to requests": "→ العودة إلى الطلبات",
  "Hello {name}, this is about your PartHub request \"{part}\" ({ref}).": "مرحباً {name}، بخصوص طلبك على PartHub «{part}» ({ref}).",
  "Hello, this is about your PartHub request \"{part}\" ({ref}).": "مرحباً، بخصوص طلبك على PartHub «{part}» ({ref}).",
  "← All requests": "→ كل الطلبات",
  "OEM number": "الرقم الأصلي OEM",
  "Wanted condition": "الحالة المطلوبة",
  "Buyer city": "مدينة المشتري",
  "Buyer's photos": "صور المشتري",
  "The buyer accepted your offer 🎉": "قبل المشتري عرضك 🎉",
  "{price} · {condition}. Contact them to arrange the sale.": "{price} · {condition}. تواصل معه لإتمام البيع.",
  "Your offer": "عرضك",
  "Send an offer": "أرسل عرضاً",
  "Price (MAD) *": "السعر (درهم) *",
  "e.g. 750": "مثلاً 750",
  "Condition *": "الحالة *",
  "Warranty (months)": "الضمان (أشهر)",
  "Ready in (days)": "جاهزة خلال (أيام)",
  "Note to buyer": "ملاحظة للمشتري",
  "Mileage, tested, original part, delivery options…": "الكيلومترات، مُجرّبة، أصلية، خيارات التوصيل…",
  "Saving…": "جارٍ الحفظ…",
  "Update offer": "حدّث العرض",
  "Send offer": "أرسل العرض",
  "Withdraw offer": "اسحب العرض",
  "The buyer sees your store name, price, condition and warranty. Their phone is shared with you only if they accept.": "يرى المشتري اسم متجرك والسعر والحالة والضمان. لا يُشارك رقمه معك إلا إذا قبل.",
  "The buyer chose another offer. Thanks for answering!": "اختار المشتري عرضاً آخر. شكراً على ردّك!",
  "This request is no longer accepting offers.": "هذا الطلب لم يعد يقبل العروض.",
  "Failed to load requests": "تعذّر تحميل الطلبات",
  "Part requests": "طلبات القطع",
  "Buyers looking for parts they couldn't find. Send an offer — if they accept, you get their contact.": "مشترون يبحثون عن قطع لم يجدوها. أرسل عرضاً، وإذا قبلوا تحصل على رقمهم.",
  "For my stock": "تناسب مخزوني",
  "All requests": "كل الطلبات",
  "Search part, make, OEM…": "القطعة، العلامة، OEM…",
  "Showing requests for makes you have compatibility data for, or categories you sell in.": "طلبات للعلامات التي لديك توافق معها أو للأصناف التي تبيعها.",
  "{n} waiting for your offer.": "{n} في انتظار عرضك.",
  "No requests right now": "لا توجد طلبات حالياً",
  "Add vehicle compatibility to your parts to get matched with more buyers, or browse all requests.": "أضف توافق السيارات لقطعك لتصلك طلبات أكثر، أو تصفّح كل الطلبات.",
  "New buyer requests will show up here.": "ستظهر الطلبات الجديدة هنا.",
  "Matches your stock": "يناسب مخزونك",
  "Your offer: {price}": "عرضك: {price}",
  "1 offer so far": "عرض واحد حتى الآن",
  "{n} offers so far": "{n} عروض حتى الآن",
  "Failed to load seller reviews": "تعذّر تحميل التقييمات",
  "Loading seller reviews...": "جارٍ تحميل التقييمات…",
  "Reviews foundation": "التقييمات",
  "Seller reviews": "تقييمات المتجر",
  "Monitor buyer feedback, track rating quality, and review comments tied to your listings.": "تابع آراء المشترين وتقييماتهم.",
  "Total reviews": "مجموع التقييمات",
  "Average rating": "متوسط التقييم",
  "5-star reviews": "تقييمات 5 نجوم",
  "Low ratings (≤2)": "تقييمات منخفضة (≤2)",
  "Search buyer, part, or review text...": "المشتري، القطعة أو النص…",
  "All ratings": "كل التقييمات",
  "5 stars": "5 نجوم",
  "4 stars": "4 نجوم",
  "3 stars": "3 نجوم",
  "2 stars": "نجمتان",
  "1 star": "نجمة واحدة",
  "{n} reviews found": "{n} تقييم",
  "No reviews yet": "لا توجد تقييمات بعد",
  "Reviews will appear here once buyers start rating your listings.": "ستظهر التقييمات هنا عندما يبدأ المشترون بتقييم عروضك.",
  "Part review": "تقييم القطعة",
  "No written review content.": "بدون تعليق.",
  "Failed to load store settings": "تعذّر تحميل الإعدادات",
  "Store display name is required.": "اسم المتجر مطلوب.",
  "Store slug is required.": "عنوان المتجر مطلوب.",
  "City is required.": "المدينة مطلوبة.",
  "Store settings saved.": "تم حفظ الإعدادات.",
  "Store created. PartHub will review it; meanwhile you can add your first parts.": "تم إنشاء المتجر. سيراجعه PartHub، وفي الأثناء يمكنك إضافة أولى قطعك.",
  "Failed to save store settings": "تعذّر حفظ الإعدادات",
  "Loading store settings...": "جارٍ تحميل الإعدادات…",
  "Manage your seller profile": "أدر ملف متجرك",
  "Create your store": "أنشئ متجرك",
  "Complete your store identity so your listings and seller presence look stronger.": "أكمل معلومات متجرك ليبدو أكثر موثوقية.",
  "Name, web address and city are enough to start. You can add the rest later.": "الاسم والعنوان والمدينة كافية للبدء. أضف الباقي لاحقاً.",
  "Store readiness": "جاهزية المتجر",
  "Store profile": "ملف المتجر",
  "These details define how your seller presence appears across the marketplace.": "هذه المعلومات تظهر للمشترين.",
  "Store display name": "اسم المتجر",
  "Store web address": "عنوان المتجر على الويب",
  "WhatsApp": "واتساب",
  "Tell buyers about your store, specialties, and trust signals...": "عرّف المشترين بمتجرك وتخصّصاتك…",
  "Logo URL": "رابط الشعار",
  "Banner URL": "رابط الغلاف",
  "Save store settings": "حفظ الإعدادات",
  "Create store": "أنشئ المتجر",
  "Preview snapshot": "معاينة",
  "Store banner": "غلاف المتجر",
  "Store logo": "شعار المتجر",
  "Your store name": "اسم متجرك",
  "City not set": "المدينة غير محددة",
  "Your store description preview will appear here.": "ستظهر معاينة الوصف هنا.",
  "What helps most": "ما يساعد أكثر",
  "A clear store name and description improve seller credibility.": "الاسم والوصف الواضحان يزيدان الثقة.",
  "City and phone make your seller profile feel more complete.": "المدينة والهاتف يكمّلان ملفك.",
  "Logo and banner URLs help your store look more professional.": "الشعار والغلاف يجعلان متجرك أكثر احترافية.",
  "Create your store to start selling": "أنشئ متجرك لتبدأ البيع",
  "It takes a few minutes: store name, city and a contact number.": "دقائق فقط: اسم المتجر والمدينة ورقم للتواصل.",
  "Finish setting up your store": "أكمل إعداد متجرك",
  "Complete the required steps below, then PartHub reviews your store.": "أكمل الخطوات المطلوبة، ثم يراجع PartHub متجرك.",
  "Your store is waiting for approval": "متجرك ينتظر الموافقة",
  "PartHub is reviewing your store. You can keep adding parts; they go live once your store is approved.": "يراجع PartHub متجرك. واصل إضافة القطع، وستُنشر بعد الموافقة.",
  "Your store is live": "متجرك منشور",
  "Buyers can find your parts and send you requests.": "يمكن للمشترين إيجاد قطعك وإرسال طلبات لك.",
  "Your store is suspended": "متجرك موقوف",
  "Your parts are hidden from buyers. Contact PartHub support to restore your store.": "قطعك مخفية عن المشترين. تواصل مع دعم PartHub لإعادة تفعيل متجرك.",
  "Your store was not approved": "لم تتم الموافقة على متجرك",
  "Update your store details and contact PartHub support to ask for a new review.": "حدّث معلومات متجرك وتواصل مع الدعم لطلب مراجعة جديدة.",
  "Edit store": "تعديل المتجر",
  "New or used": "جديدة أو مستعملة",
  "Store name, web address and city.": "الاسم والعنوان والمدينة.",
  "Add a phone or WhatsApp number": "أضف رقم هاتف أو واتساب",
  "Buyers who accept your offers contact you on this number.": "المشترون الذين يقبلون عروضك يتصلون بك على هذا الرقم.",
  "Add number": "أضف الرقم",
  "Describe your store": "صِف متجرك",
  "What you sell, which brands, delivery options (at least 40 characters).": "ما تبيعه، العلامات، خيارات التوصيل (40 حرفاً على الأقل).",
  "Write description": "اكتب الوصف",
  "List your first part": "اعرض أول قطعة",
  "Title, price in MAD, condition and stock.": "العنوان، السعر بالدرهم، الحالة والمخزون.",
  "Add part": "أضف قطعة",
  "Add photos to your parts": "أضف صوراً لقطعك",
  "Listings with photos get far more clicks.": "العروض بالصور تحصل على نقرات أكثر بكثير.",
  "Open inventory": "افتح المخزون",
  "Add vehicle compatibility": "أضف توافق السيارات",
  "Make, model and years, so buyers searching for their car find your parts.": "العلامة والطراز والسنوات، ليجد المشترون قطعك.",
  "Add a store logo": "أضف شعاراً للمتجر",
  "Shown on your public store page.": "يظهر في صفحة متجرك.",
  "Add logo": "أضف الشعار",
  "Paid": "مدفوع",
  "Unpaid": "غير مدفوع",
  "Failed": "فشل",
  "Refunded": "مسترجع",
  "Rejected": "مرفوض",
  "Suspended": "موقوف",
  "Approved": "مقبول",
  "Open for offers": "مفتوح للعروض",
  "Closed": "مغلق",
  "Fulfilled": "تمّت تلبيته",
  "Expired": "منتهي",
  "Accepted": "مقبول",
  "Declined": "مرفوض",
  "Unknown": "غير معروف",
  "Not shipped": "لم يُشحن",
  "In transit": "في الطريق",
  "1 offer so far · posted {date}": "عرض واحد حتى الآن · نُشر في {date}",
  "{n} offers so far · posted {date}": "{n} عروض حتى الآن · نُشر في {date}",
  "This page does not exist.": "هذه الصفحة غير موجودة.",

  // Buyers waiting for out-of-stock parts
  "1 buyer is waiting for your parts": "مشترٍ واحد ينتظر قطعك",
  "{n} buyers are waiting for your parts": "{n} مشترين ينتظرون قطعك",
  "They asked to be told when these parts are back in stock. Restock them and PartHub notifies them right away.": "طلبوا إعلامهم عند عودة هذه القطع. أعد توفيرها وسيُعلمهم PartHub فوراً.",
  "1 buyer waiting": "مشترٍ واحد ينتظر",
  "{n} buyers waiting": "{n} مشترين ينتظرون",
  "Stock: {n}": "المخزون: {n}",
  "Update stock": "حدّث المخزون",
  "Buyers waiting": "مشترون ينتظرون",
  "1 buyer waiting for this part": "مشترٍ واحد ينتظر هذه القطعة",
  "{n} buyers waiting for this part": "{n} مشترين ينتظرون هذه القطعة",
  "1 buyer is waiting for this part": "مشترٍ واحد ينتظر هذه القطعة",
  "{n} buyers are waiting for this part": "{n} مشترين ينتظرون هذه القطعة",
  "Set the quantity above 0 and save: they are notified right away.": "ضع كمية أكبر من 0 واحفظ، وسيُعلَمون فوراً.",

  // Add-a-part wizard and photos
  "The part": "القطعة",
  "Price & stock": "السعر والمخزون",
  "Fits which vehicles": "السيارات المتوافقة",
  "Review": "المراجعة",
  "You can add up to {n} photos.": "يمكنك إضافة {n} صور كحد أقصى.",
  "Photos": "الصور",
  "Up to {n} photos. The first one is the main photo. Listings with real photos get far more clicks.": "حتى {n} صور. الأولى هي الصورة الرئيسية. العروض بصور حقيقية تحصل على نقرات أكثر بكثير.",
  "Main": "رئيسية",
  "Make main": "اجعلها رئيسية",
  "Remove photo": "حذف الصورة",
  "Remove": "حذف",
  "Uploading…": "جارٍ الرفع…",
  "Add photos": "أضف صوراً",
  "Origin": "المصدر",
  "Aftermarket": "بديلة",
  "Used Part": "قطعة مستعملة",
  "OEM": "أصلية (OEM)",
  "Give the part a clear title (at least 4 characters).": "أعطِ القطعة عنواناً واضحاً (4 أحرف على الأقل).",
  "Choose a category.": "اختر صنفاً.",
  "Wait for the photos to finish uploading.": "انتظر حتى يكتمل رفع الصور.",
  "The price before discount must be higher than the price.": "السعر قبل التخفيض يجب أن يكون أعلى من السعر.",
  "Quantity must be 0 or more.": "الكمية يجب أن تكون 0 أو أكثر.",
  "Each vehicle needs a make and a model, or remove the row.": "كل سيارة تحتاج علامة وطرازاً، أو احذف السطر.",
  "Year must be between 1950 and {maxYear}": "السنة يجب أن تكون بين 1950 و{maxYear}",
  "The end year must be the same as or after the start year.": "سنة النهاية يجب أن تساوي سنة البداية أو تليها.",
  "A photo could not be attached. Add it again from the edit page.": "تعذّر إرفاق صورة. أضفها من صفحة التعديل.",
  "Part saved": "تم حفظ القطعة",
  "It is live in the catalog.": "القطعة منشورة في الكتالوج.",
  "PartHub reviews new listings before they go live. You'll see the status in your inventory.": "يراجع PartHub العروض الجديدة قبل نشرها. ستجد الحالة في مخزونك.",
  "+ Add another part": "+ أضف قطعة أخرى",
  "Edit this part": "عدّل هذه القطعة",
  "Add a part": "أضف قطعة",
  "Five short steps. Your progress is saved on this device.": "خمس خطوات قصيرة. يُحفظ تقدّمك على هذا الجهاز.",
  "Start over": "ابدأ من جديد",
  "Steps": "الخطوات",
  "Step {n} of {total}": "الخطوة {n} من {total}",
  "What are you selling?": "ماذا تبيع؟",
  "Part name, then brand and vehicle, e.g. “Front brake pads Bosch – Clio 4”.": "اسم القطعة ثم العلامة والسيارة، مثلاً «فحمات أمامية Bosch – Clio 4».",
  "e.g. Alternator Valeo 90A Clio IV 1.5 dCi": "مثلاً: دينامو Valeo 90A Clio IV 1.5 dCi",
  "Suggested: {name}": "مقترح: {name}",
  "Brand (optional)": "العلامة (اختياري)",
  "No brand / not sure": "بدون علامة / لست متأكداً",
  "OEM = made by the car maker. Aftermarket = compatible part from another brand.": "أصلية = من صانع السيارة. بديلة = قطعة متوافقة من علامة أخرى.",
  "OEM / part number (optional)": "الرقم الأصلي / رقم القطعة (اختياري)",
  "Buyers often search by this number.": "كثير من المشترين يبحثون بهذا الرقم.",
  "Close": "إغلاق",
  "Tip: a photo of the real part (and its label or reference) builds trust. You can also add photos later.": "نصيحة: صورة القطعة الحقيقية (وملصقها أو رقمها) تزيد الثقة. يمكنك إضافة الصور لاحقاً أيضاً.",
  "e.g. 350 or 349,90": "مثلاً 350 أو 349,90",
  "Price before discount (optional)": "السعر قبل التخفيض (اختياري)",
  "Shown crossed out next to the price.": "يظهر مشطوباً بجانب السعر.",
  "Quantity in stock": "الكمية في المخزون",
  "Decrease quantity": "إنقاص الكمية",
  "Increase quantity": "زيادة الكمية",
  "Description (optional)": "الوصف (اختياري)",
  "Mileage, tested or not, what's included, delivery options…": "الكيلومترات، مجرّبة أم لا، ما يتضمّنه، خيارات التوصيل…",
  "Fits which vehicles?": "تناسب أي سيارات؟",
  "Optional, but buyers who search by their car see compatible parts first, and you get matched with their part requests.": "اختياري، لكن المشترين الذين يبحثون بسيارتهم يرون القطع المتوافقة أولاً، وتصلك طلباتهم.",
  "Select make": "اختر العلامة",
  "Select model": "اختر الطراز",
  "Choose make first": "اختر العلامة أولاً",
  "From": "من",
  "To": "إلى",
  "+ Add a vehicle": "+ أضف سيارة",
  "You can add more details (engine, trim) later from the edit page.": "يمكنك إضافة تفاصيل (المحرك، الفئة) لاحقاً من صفحة التعديل.",
  "Check and publish": "راجع وانشر",
  "Vehicles": "السيارات",
  "None": "لا شيء",
  "Edit": "تعديل",
  "New listings are reviewed by PartHub before they go live.": "يراجع PartHub العروض الجديدة قبل نشرها.",
  "Back": "رجوع",
  "Skip for now": "تخطَّ الآن",
  "Next": "التالي",
  "Publish part": "انشر القطعة",

  // Category names used in production
  "Body & Exterior": "الهيكل والخارج",
  "Brakes & Rotors": "الفرامل والأقراص",
  "Cooling System": "نظام التبريد",
  "Electrical & Lighting": "الكهرباء والإنارة",
  "Engine Parts": "قطع المحرك",
  "Exhaust & Emissions": "العادم والانبعاثات",
  "Filters & Fluids": "الفلاتر والسوائل",
  "Interior & Accessories": "الداخلية والإكسسوارات",
  "Suspension & Steering": "التعليق والمقود",
  "Tires & Wheels": "الإطارات والعجلات",
  "Tools & Equipment": "الأدوات والمعدات",
  "Transmission & Drivetrain": "ناقل الحركة",
  "Brakes": "الفرامل",
  "Electrical": "الكهرباء",
  "Filters": "الفلاتر",
  "Fluids & Oils": "السوائل والزيوت",
};
